

















































import { NODE_ENV } from '@/config'
import store from '@/store'
import { Component, Vue } from 'vue-property-decorator'
import { Icon, Card, Button } from '@alpha/ink'
import LoadingIndicator from '@/components/LoadingIndicator.vue'
import Toggle from '@/components/Toggle.vue'

@Component({
  components: {
    Toggle,
    LoadingIndicator,
    Icon,
    Card,
    Button
  }
})
export default class ShareLinkMenu extends Vue {
  generatingSharedLink: boolean = false
  removingSharedLink: boolean = false
  copied: boolean = false
  copiedTimeout: NodeJS.Timeout | null = null

  get copyLinkText () {
    return this.copied ? 'Link copied to clipboard' : 'Copy link to clipboard'
  }

  get shareLinkText () {
    return `Share link ${this.testSharedLink ? 'enabled' : 'disabled'}`
  }

  get sharedLinkHash () {
    return store.state.surveyConfiguration.sharedLinkHash!
  }

  get loading () {
    return !store.state.surveyConfiguration.workspaceId
  }

  get testSharedLink () {
    if (this.sharedLinkHash) {
      return `${NODE_ENV !== 'development' ? 'https' : 'http'}://${document.location.host}/results/${this.sharedLinkHash}`
    } else {
      return null
    }
  }

  copyLinkToClipboard () {
    this.copied = false
    const shareLinkElement = this.$refs.shareLink as HTMLInputElement
    shareLinkElement.select()
    shareLinkElement.setSelectionRange(0, 99999) // mobile
    const success = document.execCommand('copy')
    this.setCopied(success)
  }

  setCopied (value: boolean) {
    if (this.copiedTimeout) {
      clearTimeout(this.copiedTimeout)
    }
    this.copied = value
    if (value) {
      this.copiedTimeout = setTimeout(() => {
        this.copied = false
      }, 3000)
    }
  }

  async generateSharedLink () {
    this.generatingSharedLink = true
    const success = await store.dispatch.surveyConfiguration.toggleSharedLink({
      testId: this.$route.params.testId,
      workspaceId: store.state.workspace.workspace.id,
      createLink: true
    })
    this.generatingSharedLink = false
    if (success) {
      this.copyLinkToClipboard()
    }
  }

  async disableSharedLink () {
    this.removingSharedLink = true
    await store.dispatch.surveyConfiguration.toggleSharedLink({
      testId: this.$route.params.testId,
      workspaceId: store.state.workspace.workspace.id,
      createLink: false
    })
    this.setCopied(false)
    this.removingSharedLink = false
  }
}
